import actionTypes from '../../actions/actionTypes'
import { Map, fromJS, List } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { deleteItem } from './helpers'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.itemSelections)

const _itemSelectionsFactory = (pk, cinemas, title, filterType = null, filterValue = null, expireDate = null , draft = false, collections = []) => {
    return Map({
        pk: pk,
        cinemas: List(cinemas),
        title: title,
        filterType: filterType,
        filterValue: filterValue,
        expireDate: expireDate,
        draft: draft,
        collections: List(collections)
    })
}

const addItemSelections = (state, action) => state.setIn(
    ['items', action.payload.pk.toString()], 
    _itemSelectionsFactory(
        action.payload.pk, 
        action.payload.cinemas,
        action.payload.title, 
        action.payload.filterType, 
        action.payload.filterValue, 
        action.payload.expireDate,
        action.payload.draft,
        action.payload.collections
    )
)

// const updateItemSelections = (state, action) => state.setIn(['items', action.payload.id], fromJS(action.payload.updatedItemSelections))



const updateItemSelectionAttribute = (state, action, attribute) => state.setIn(['items', action.payload.pk, attribute], action.payload[attribute])

const updateItemSelectionSettings = (state, action) => {
    state = updateItemSelectionAttribute(state, action, 'title')
    state = updateItemSelectionAttribute(state, action, 'style')
    state = updateItemSelectionAttribute(state, action, 'trailerAutoplay')
    state = updateItemSelectionAttribute(state, action, 'cinemasFilter')

    return state
}


const itemSelectionsReducer = (state = INIT_STATE, action) => {
    
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.ITEMSELECTIONS_ADD_ITEM:
            return addItemSelections(state, action);
        case actionTypes.ITEMSELECTIONS_DELETE_ITEM:
            return deleteItem(state, action);
        case actionTypes.ITEMSELECTIONS_UPDATE_ITEM_SETTINGS:
            return updateItemSelectionSettings(state, action)
        case actionTypes.ITEMSELECTIONS_UPDATE_ITEM_SHOWINAPP:
            return updateItemSelectionAttribute(state, action, 'showInApp')
        default:
            return state;
    }
}

export default itemSelectionsReducer;